import Icon from '../components/Icon.vue'

Icon.register({
  'caret-square-right': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M48 32H400C426.5 32 448 53.5 448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32zM188.5 387.5L311.5 264.5C316.2 259.8 316.2 252.2 311.5 247.5L188.5 124.5C180.9 116.9 168 122.3 168 133V379C168 389.7 180.9 395.1 188.5 387.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-square-right.js
// module id = iHKC
// module chunks = 144